<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl">
        <v-card-title>
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark>mdi-arrow-left</v-icon>
          </v-btn>
          Add Recharged Benefit Rewards
        </v-card-title>
        <v-card-text>
          <!-- Common Fields -->
          <v-row>
            <v-col sm="6">
              <v-text-field
                v-model="commonFields.title"
                outlined
                label="Offer Name"
                prepend-inner-icon="mdi-tag"
                :error-messages="errors.title"
              ></v-text-field>
            </v-col>

            <v-col sm="6">
              <v-text-field
                v-model="commonFields.recharge_amount"
                outlined
                label="Recharge Amount"
                prepend-inner-icon="mdi-currency-inr"
                type="number"
                min="0"
                step="0.01"
                :error-messages="errors.recharge_amount"
              ></v-text-field>
            </v-col>
          </v-row>

          <v-divider class="my-4"></v-divider>

          <!-- Rewards Section -->
          <div class="d-flex align-center mb-4">
            <h3 class="text-h6">Rewards</h3>
            <v-spacer></v-spacer>
            <v-btn
              color="success"
              small
              rounded
              @click="addReward"
            >
              <v-icon left small>mdi-plus</v-icon>
              Add Reward
            </v-btn>
          </div>

          <!-- Reward Cards -->
          <v-row>
            <v-col
              v-for="(reward, index) in rewards"
              :key="index"
              cols="12"
            >
              <v-card outlined class="pa-4 mb-3">
                <div class="d-flex align-center mb-3">
                  <h4 class="text-subtitle-1">Reward #{{ index + 1 }}</h4>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    small
                    color="error"
                    @click="removeReward(index)"
                    v-if="rewards.length > 1"
                  >
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </div>

                <v-row>
                  <!-- Reward Type -->
                  <v-col sm="4">
                    <v-autocomplete
                      v-model="reward.reward_type"
                      outlined
                      dense
                      :items="rewardTypeItems"
                      item-text="text"
                      item-value="value"
                      label="Reward Type"
                      prepend-inner-icon="mdi-gift"
                      @change="onRewardTypeChange(index)"
                    ></v-autocomplete>
                  </v-col>

                  <!-- Coin Amount (conditional) -->
                  <v-col sm="4" v-if="reward.reward_type === 'coin'">
                    <v-text-field
                      v-model="reward.coin_amount"
                      outlined
                      dense
                      label="Coins Earned"
                      prepend-inner-icon="mdi-bitcoin"
                      type="number"
                      min="0"
                      step="0.01"
                    ></v-text-field>
                  </v-col>

                  <!-- Store Item (conditional) -->
                  <v-col sm="4" v-if="reward.reward_type === 'store_item'">
                    <v-autocomplete
                      v-model="reward.store_item_id"
                      outlined
                      dense
                      :items="storeItems"
                      item-text="text"
                      item-value="value"
                      label="Store Item"
                      prepend-inner-icon="mdi-store"
                      clearable
                    ></v-autocomplete>
                  </v-col>

                  <!-- Duration (conditional) -->
                  <v-col sm="4" v-if="reward.reward_type === 'store_item'">
                    <v-text-field
                      v-model="reward.duration"
                      outlined
                      dense
                      label="Duration (Days)"
                      prepend-inner-icon="mdi-calendar-clock"
                      type="number"
                      min="0"
                      hint="0 for Permanent"
                      persistent-hint
                    ></v-text-field>
                  </v-col>
                </v-row>
              </v-card>
            </v-col>
          </v-row>

          <!-- Status -->
          <v-row>
            <v-col sm="12">
              <v-switch
                v-model="commonFields.is_active"
                inset
                color="primary"
                :label="`Status: ${commonFields.is_active ? 'Active' : 'Inactive'}`"
              ></v-switch>
            </v-col>
          </v-row>

          <v-divider class="mt-5 mb-5"></v-divider>

          <v-btn
            :loading="isLoading"
            :disabled="isLoading || rewards.length === 0"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Save All Rewards ({{ rewards.length }})
          </v-btn>
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>
<script>
import axios from "axios";
export default {
  name: "RechargedBenefitCreatePage",
  data() {
    return {
      commonFields: {
        title: "",
        recharge_amount: 0,
        is_active: true,
      },
      rewards: [
        {
          reward_type: "",
          coin_amount: null,
          store_item_id: null,
          duration: 0,
        },
      ],
      storeItems: [],
      rewardTypeItems: [
        { id: 1, text: "Coin", value: "coin" },
        { id: 2, text: "Store Item", value: "store_item" },
      ],
      isLoading: false,
    };
  },
  mounted() {
    this.getMasters();
  },
  methods: {
    async getMasters() {
      await axios
        .get(`masters?context=reward_category`)
        .then((masters) => {
          masters = masters.data;
          //Store Items
          if (masters.storeItem) {
            masters.storeItem.forEach((storeItem) => {
              this.storeItems.push({
                id: storeItem.id,
                text: storeItem.name,
                value: storeItem.id,
              });
            });
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    addReward() {
      this.rewards.push({
        reward_type: "",
        coin_amount: null,
        store_item_id: null,
        duration: 0,
      });
    },
    removeReward(index) {
      this.rewards.splice(index, 1);
    },
    onRewardTypeChange(index) {
      // Reset fields based on reward type
      const reward = this.rewards[index];
      if (reward.reward_type === 'coin') {
        reward.store_item_id = null;
        reward.duration = 0;
      } else if (reward.reward_type === 'store_item') {
        reward.coin_amount = null;
      }
    },
    async save() {
      try {
        this.isLoading = true;

        // Prepare payload as per backend requirements
        const payload = {
          title: this.commonFields.title,
          recharge_amount: this.commonFields.recharge_amount,
          rewards: this.rewards.map(reward => ({
            title: this.commonFields.title,
            reward_type: reward.reward_type,
            coin_amount: reward.coin_amount,
            store_item_id: reward.store_item_id,
            recharge_amount: this.commonFields.recharge_amount,
            duration: reward.duration,
            is_active: this.commonFields.is_active,
          }))
        };

        // Send single request with all rewards
        const response = await axios.post("/recharged_benefits", payload);

        this.isLoading = false;

        if (response.data.success) {
          this.$router.push("/rechargedbenefits");
        }
      } catch (e) {
        this.isLoading = false;
        console.log(e);
        if (e.response && e.response.data) {
          this.errors = e.response.data.errors || {};
        }
      }
    },
  },
};
</script>